import angular from 'angular';
import { default as authorizationService } from 'app/services/membership/ss.authorization.service';
import { default as orgDataService } from 'app/services/data/org.data.service';
import { default as userService } from 'app/services/membership/ss.user.service';
import { default as editSupportTicketDialog } from 'app/components/global/editSupportTicketDialog';
import { default as applicationNotifications } from 'app/components/global/applicationNotifications';
import orgSharedModelService from 'app/services/sharedModels/org.sharedModel.service';
import contactUsDialog from './dialog.contactUsDialog';
import switchBanksDialog from './dialog.switchBanksDialog';
import controller from './user-bar.controller';
import directive from './user-bar.directive';

const library = require('@safe-systems/ss-ui-components');

const { loaderService, ssDialogService } = library;

export default angular
  .module('app.components.global.userBar', [
    authorizationService,
    contactUsDialog,
    switchBanksDialog,
    loaderService,
    orgDataService,
    orgSharedModelService,
    editSupportTicketDialog,
    ssDialogService,
    userService,
    applicationNotifications,
  ])
  .directive('userBar', directive)
  .controller('userBarController', controller)
  .factory('navUiState', function () {
    return { dismissed: false };
  }).name;

console.log('app.components.global.userBar created');
